import { render, staticRenderFns } from "./ShowTempNgo.vue?vue&type=template&id=04db7fa8&"
import script from "./ShowTempNgo.vue?vue&type=script&lang=js&"
export * from "./ShowTempNgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports